import { useTranslation } from "react-i18next";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { connect } from "socket.io-client";
import {
  apiGetClosestMatch,
  getTemplateById,
} from "../../../../services/backend/api.service";
import _ from "lodash";

import { fadeIn, fadeOut } from "../../../../animations/timeline";

import FrontendConfig from "../../../../config/frontend";
import frontendConfig from "../../../../config/frontend";
import BackendConfig from "../../../../config/backend";

import { templates as templateComponents } from "../../../frontend/pages/Template/index";
import preloadImages from "../../functions/preloadImages";
import getImagesToPreload from "../../functions/getImagesToPreload";
import { useGlobalFrontendStore } from "../../../../stores/globalFrontendStore";

import { asyncTimeout, sleepFn } from "../../functions/timeout";

import "./styles.scss";
import VideoModeWrapper from "../../../shared/components/VideoModeWrapper/Index";
import { useIsMounted } from "../../../../hooks";
// import timelineMainBg from "../../../../assets/timeline/timeline_season_2023.jpg";
import worldcupTransition from "../../../frontend/assets/wc/videos/samsung_transition.webm";
import oneFootballTransition from "../../../frontend/assets/of/videos/wipe.webm";
import {
  getCurrentTimelineLink,
  getCurrentTimelineLinkAdler,
} from "../../utils/opta/timeline";
// import timelineMainBg from "../../../../assets/timeline/timeline_season_2023.jpg";
// import timelineMainBg from "../../../../assets/timeline/timeline_playoffs_2023.jpg";
import timelineMainBg from "../../../../assets/timeline/timeline_adler_2023.png";
import backendConfig from "../../../../config/backend";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import TimelineLiveIndicator from "../../../frontend/templates/_partials/TimelineLiveIndicator/Index";
import { getTemplateDurationOveride } from "../../utils/timeline";
import { Button } from "antd";
import AlarmTemplate from "./alarmTemplate";
import { useWebsocket } from "../../contexts/websocket";
import { axios } from "../../../../services/axios";

// Import the ad bumper and countdown videos
import adBumperCountdownDe from "../../../../assets/ads/sportworld/adbumper-countdown-de.webm";
import adBumperCountdownEn from "../../../../assets/ads/sportworld/adbumper-countdown-en.webm";
import adBumperIntroDe from "../../../../assets/ads/sportworld/adbumper-intro-de.webm";
import adBumperIntroEn from "../../../../assets/ads/sportworld/adbumper-intro-en.webm";
import adBumperOutro from "../../../../assets/ads/sportworld/adbumper-outro.webm";
import frontend from "../../../../config/frontend";

const templateTestSwitch = 3000;
const REFRESH_TIMELINE_EVERY_X_TEMPLATES = 4;
let timelineStats = {};

const waitingKeypress = () => {
  return new Promise((resolve) => {
    document.addEventListener("keydown", onKeyHandler);
    function onKeyHandler(e) {
      // spacebar
      if (e.keyCode === 32) {
        document.removeEventListener("keydown", onKeyHandler);
        resolve();
      }
    }
  });
};

const Index = (props) => {
  const isMounted = useIsMounted();
  const timeoutRef = useRef();
  const alarmTimeoutRef = useRef();

  const [messageQueue, setMessageQueue] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  // Although we still get a socket from context, ad breaks are now triggered solely via axios.
  const { socket } = useWebsocket();

  const {
    previewFormat,
    timelineData,
    changeEmitter,
    mode,
    setRefreshTimeline,
    style,
  } = props;
  const apiSetup = useGlobalFrontendStore((state) => state.apiSetup);
  const setClosestMatch = useGlobalFrontendStore((state) => state.setClosestMatch);
  const setReloadTimeline = useGlobalFrontendStore((state) => state.setReloadTimeline);
  const closestMatch = useGlobalFrontendStore((state) => state.closestMatch);
  const timelineCurrentSlide = useGlobalFrontendStore((state) => state.timelineCurrentSlide);
  const timelineAction = useGlobalFrontendStore((state) => state.timelineAction);
  const setTimelineCurrentSlide = useGlobalFrontendStore((state) => state.setTimelineCurrentSlide);

  const onTimelineAction = (data) => {
    if (typeof changeEmitter === "function") {
      const merged = _.merge(timelineStats, data);
      changeEmitter(merged);
    }
  };

  const { t } = useTranslation();

  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [initialied, setInitialized] = useState(false);
  const [showTemplateVideo, setShowTemplateVideo] = useState(false);
  const [videoShowStart, setVideoShowStart] = useState(true);
  const [videoShowEnd, setVideoShowEnd] = useState(false);
  const [ready, setReady] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesData, setSlidesData] = useState([]);
  const [loopTimes, setLoopTimes] = useState(0);
  const [processed, setProcessed] = useState(0);
  const [errorState, setErrorState] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [showAlarm, setShowAlarm] = useState("");
  const [alarmData, setAlarmData] = useState(null);
  const [totalSlidesViewed, setTotalSlidesViewed] = useState(0);

  // New state to manage the ad break overlay and its phase.
  const [adBreakActive, setAdBreakActive] = useState(false);
  // adPhase: "intro", "countdown", "outro", or null.
  const [adPhase, setAdPhase] = useState(null);

  // Create a ref for adBreakActive so that the interval always has the latest value.
  const adBreakActiveRef = useRef(adBreakActive);
  useEffect(() => {
    adBreakActiveRef.current = adBreakActive;
  }, [adBreakActive]);

  // NEW: Create a ref to track when the last ad break ended (for cooldown).
  const lastAdBreakEndTimeRef = useRef(0);

  // Helper wait function (in ms)
  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const search = useLocation()?.search;
  const searchParams = new URLSearchParams(search);

  const adsEnabled = searchParams.get("ads")?.toLowerCase() === "true";
  // Use x-slides only if x-interval is not provided.
  const xIntervalProvided = searchParams.has("x-interval");
  const xSlides = parseInt(searchParams?.get("x-slides") || 15, 10);
  // Updated default xDuration is 120 seconds.
  const xDuration = parseInt(searchParams?.get("x-duration") || 120, 10);
  // Note: xAdsInterval default 10 minutes
  const xAdsInterval = parseInt(searchParams?.get("x-interval") || 10 * 60, 10);
  const queryLng = searchParams.get("lng") || "en";

  // Create a ref for currentIndex so that the latest value is used inside intervals.
  const currentIndexRef = useRef(currentIndex);
  useEffect(() => {
    currentIndexRef.current = currentIndex;
  }, [currentIndex]);

  const timelinePlayMode = _.get(timelineData, "options.mode", "auto");
  const timelineTransition = _.get(
    timelineData,
    "options.transition",
    FrontendConfig.timeline.transitionType,
  );
  const fadeInDuration = FrontendConfig.timeline.fadeInDuration;

  const [activeSlot, setActiveSlot] = useState("current");
  const [slotCurrentData, setSlotCurrentData] = useState();
  const [slotNextData, setSlotNextData] = useState();

  const templates = _.get(timelineData, "templates", []);

  const [nextMode, setNextMode] = useState("static");
  const [currentMode, setCurrentMode] = useState("static");

  const currentData = _.find(slidesData, { currentIndex });
  const nextData =
    templates.length === currentIndex + 1
      ? _.find(slidesData, { currentIndex: 0 })
      : _.find(slidesData, { currentIndex: currentIndex + 1 });
  const transitionVideo = $(`.timeline-transition-video`);
  const videoDom = transitionVideo.get(0);

  const competitionId = timelineData?.event?.competitionId;

  const processQueue = useCallback(async () => {
    const [nextMessage, ...remainingQueue] = messageQueue;
    setMessageQueue(remainingQueue);
    if (nextMessage) {
      await processMessage(nextMessage);
    }
    await new Promise((resolve) => setTimeout(resolve, 2000));
    setIsProcessing(false);
  }, [messageQueue]);

  const incrementInLoop = (optionalIndex) => {
    setCurrentIndex((currentIndex) => {
      if (optionalIndex > -1) {
        return optionalIndex;
      }
      const incremented = processed;
      if (templates.length == incremented) {
        return 0;
      }
      return incremented;
    });
  };

  const getNextIndex = (current) => {
    if (current + 1 === templates.length) {
      return 0;
    }
    return current + 1;
  };

  const goToPageIndex = async (index) => {
    if (index < 0) return;
    if (index >= templates.length) {
      index = 0;
    }
    if (timeoutRef.current) {
      timeoutRef.current.clear();
    }
    setSlotNextData(null);
    await asyncTimeout(100);
    const nextId = _.get(templates, `${index}.templateId`);
    const nextTemplate = _.get(templates, `${index}.template`);
    const preloadNext = await getTemplateById({
      id: nextId,
      template_name: nextTemplate,
    }).catch((err) => {
      console.error(err);
    });
    const preloadNextData = _.get(preloadNext, "data", null);
    if (!preloadNextData) {
      setErrorState(true);
    }
    setSlidesData((slidesData) => {
      const newSlidesData = [
        ...slidesData.filter(
          (item) =>
            item.currentIndex === currentIndex || item.currentIndex === index,
        ),
        {
          currentIndex: index,
          ...preloadNextData,
        },
      ];
      if (newSlidesData.length > 3) {
        newSlidesData.shift();
      }
      return newSlidesData;
    });
    setCurrentMode("static");
    setNextMode("static");
    setSlotNextData(preloadNextData);
    fadeOut({
      slide: "current",
      duration: timelineTransition === "video" ? 0 : 1000,
    });
    setProcessed(index);
    setCurrentIndex(index);
    if (currentIndex === index) {
      setRefresh((refresh) => !refresh);
    }
    setActiveSlot("next");
    fadeIn({ slide: "next", duration: 1000 });
  };

  useEffect(() => {
    if (timelineCurrentSlide !== null) {
      const index = timelineCurrentSlide.index;
      const asyncCall = async () => {
        goToPageIndex(index);
      };
      asyncCall();
    }
  }, [timelineCurrentSlide]);

  useEffect(() => {
    const action = timelineAction?.action;
    if (action) {
      if (action === "next") {
        goToPageIndex(currentIndex + 1);
      } else {
        goToPageIndex(currentIndex - 1);
      }
    }
  }, [timelineAction]);

  useEffect(() => {
    if (errorState) {
      throw new Error("Error state, trigger....", errorState);
    }
    return () => {
      setErrorState(false);
    };
  }, [errorState]);

  useEffect(() => {
    const asyncCall = async () => {
      const timelineAutoLinkEnabled = _.get(
        apiSetup,
        "timeline.settings.timelineAutoLinkEnabled",
        false,
      );
      if (currentIndex === 0 && timelineAutoLinkEnabled) {
        const closestMatchApi = await apiGetClosestMatch({
          competitionId,
        }).catch((err) => {
          console.error("Timeline closestMatch err", err);
          setReloadTimeline(true);
          setTimeout(() => {
            window.location.reload();
          }, 5000);
        });
        if (closestMatchApi?.data) {
          setClosestMatch(closestMatchApi?.data);
        }
      }
      if (
        (currentIndex + 1) % REFRESH_TIMELINE_EVERY_X_TEMPLATES === 0 &&
        templates.length !== currentIndex + 1
      ) {
        setRefreshTimeline(true);
      }
    };
    asyncCall();
  }, [currentIndex]);

  useEffect(() => {
    if (templates?.length === 0) {
      console.warn("TIMELINE_PREVIEW:templates empty", {
        name: timelineData?.name,
        uuid: timelineData?.uuid,
        format: timelineData?.format,
        templates,
      });
      setTimeout(() => {
        window.location.reload();
      }, 5000);
      throw new Error("TIMELINE_PREVIEW:templates empty");
    }
  }, [templates]);

  useEffect(() => {
    const timelineAutoLinkEnabled = _.get(
      apiSetup,
      "timeline.settings.timelineAutoLinkEnabled",
      false,
    );
    const timelineLinks = closestMatch?.matchdayTimelines || [];
    let skipLogic = true;
    timelineLinks.map((entry) => entry.uuid).forEach((check) => {
      if (window.location.href.indexOf(check) > -1) {
        skipLogic = false;
      }
    });
    if (
      closestMatch?.closestMatch &&
      currentIndex === 0 &&
      timelineAutoLinkEnabled &&
      !skipLogic
    ) {
      let timelineLink =
        backendConfig?.clientBodyClass === "app-adler"
          ? getCurrentTimelineLinkAdler(closestMatch)
          : getCurrentTimelineLink(closestMatch);
      if (timelineData?.name?.includes("PRE-LIVE-POST-MATCHDAY")) {
        timelineLink = null;
      }
      if (timelineLink?.link) {
        const currentUrl = new URL(window.location.href);
        const targetUrl = new URL(timelineLink.link);
        currentUrl.searchParams.forEach((value, key) => {
          targetUrl.searchParams.set(key, value);
        });
        if (
          timelineLink?.link &&
          window.location.href.indexOf(timelineLink.uuid) === -1
        ) {
          if (window.location.href !== targetUrl) {
            window.location.replace(targetUrl);
          }
        }
      }
    }
  }, [closestMatch, currentIndex]);

  // Preload first two slides data
  useEffect(() => {
    if (!isMounted.current) {
      return;
    }
    const asyncCall = async () => {
      if (!templates.length) {
        return [];
      }
      const preload1 = await getTemplateById({
        id: templates[currentIndex]?.templateId,
        template_name: templates[currentIndex]?.template,
      }).catch((err) => {
        console.error("preload1", err);
      });
      let preload2 = null;
      let preload2Data = null;
      if (currentIndex + 1 < templates.length) {
        preload2 = await getTemplateById({
          id: templates[currentIndex + 1]?.templateId,
          template_name: templates[currentIndex + 1]?.template,
        }).catch((err) => {
          console.error("preload2", err);
        });
        preload2Data = _.get(preload2, "data", null);
        if (!preload2Data) {
          setErrorState(true);
          return;
        }
      }
      const preload1Data = _.get(preload1, "data", null);
      if (!preload1Data) {
        setErrorState(true);
        return;
      }
      setSlidesData((slidesData) => {
        setSlotCurrentData(preload1Data);
        setSlotNextData(preload2Data);
        return [
          {
            currentIndex: currentIndex,
            ...preload1Data,
          },
          {
            currentIndex: currentIndex + 1,
            ...preload2Data,
          },
        ];
      });
    };
    asyncCall();
  }, []);

  // Preload next slide
  useEffect(() => {
    if (!templates.length) {
      return;
    }
    const asyncCall = async () => {
      const nextIndex = getNextIndex(currentIndex);
      const nextId = _.get(templates, `${nextIndex}.templateId`);
      const nextTemplate = _.get(templates, `${nextIndex}.template`);
      const preloadNext = await getTemplateById({
        id: nextId,
        template_name: nextTemplate,
      }).catch((err) => {
        console.error(err);
      });
      const preloadNextData = _.get(preloadNext, "data", null);
      if (!preloadNextData) {
        setErrorState(true);
      }
      setSlidesData((slidesData) => {
        const newSlidesData = [
          ...slidesData.filter((item) => item.currentIndex === currentIndex),
          {
            currentIndex: nextIndex,
            ...preloadNextData,
          },
        ];
        if (newSlidesData.length > 3) {
          newSlidesData.shift();
        }
        return newSlidesData;
      });
      if (currentIndex + 1 === templates.length) {
        onTimelineAction({
          ...timelineStats,
          totalLoops: loopTimes + 1,
        });
        setLoopTimes((times) => times + 1);
        setRefreshTimeline(true);
      }
    };
    asyncCall();
  }, [refresh, currentIndex, templates.length]);

  // Init ready: images loaded, slidesData ready
  useEffect(() => {
    if (slidesData && !ready && imagesLoaded) {
      if (mode === "video") {
      } else {
        setReady(true);
      }
    }
  }, [slidesData, imagesLoaded]);

  // Process templates
  useEffect(() => {
    const asyncCall = async () => {
      if (!ready || processed > currentIndex || !currentData || !nextData) return;

      const options = _.get(currentData, "data.options", []);
      const {
        firstSlideDelay,
        fadeOutDuration,
        fadeInDuration,
        videoTransitionBefore,
        videoTransitionAfter,
        testMode,
        testData,
        defaultDuration,
      } = FrontendConfig.timeline;
      let templateDuration = parseInt(
        getTemplateDurationOveride({
          apiSetup,
          tournamentId: competitionId,
          fallback: _.get(_.find(options, { id: "videoduration" }), "value", defaultDuration),
          templateName: currentData?.template_name,
          event: currentData?.event,
        })
      );

      if (testMode) {
        templateDuration = testData.templateDuration;
      }

      const durationMs = templateDuration * 1000;
      const isVideoTransition = timelineTransition === "video";
      const adjustedDuration = isVideoTransition
        ? durationMs - videoTransitionBefore
        : durationMs;

      const templateName = _.get(currentData, "template_name");

      onTimelineAction({
        currentSlide: currentIndex + 1,
        totalSlides: templates.length,
        currentTemplate: templateName,
        currentDuration: adjustedDuration,
        nextTemplate: _.get(nextData, "template_name"),
      });

      if (currentIndex === 0 && loopTimes === 0) {
        if (timelinePlayMode === "manual" && mode !== "video") {
          await waitingKeypress();
        } else {
          await asyncTimeout(firstSlideDelay);
        }
      }

      if (!isMounted.current) return;
      if (testMode) console.time("TEMPLATE SLIDE TIME");

      onTimelineAction({ state: "TIMELINE_START" });

      setCurrentMode(activeSlot === "current" ? "animation" : "static");
      setNextMode(activeSlot === "current" ? "static" : "animation");

      fadeIn({ slide: activeSlot, duration: fadeInDuration });

      if (templateName === "staticmedia") {
        const containerSelector = activeSlot === "current" ? ".active-slide" : ".next-slide";
        const videoBg = $(`${containerSelector} video.custom-background`).get(0);
        if (videoBg) {
          videoBg.currentTime = 0;
          setTimeout(() => videoBg.play(), fadeInDuration / 2);
        }
      }

      onTimelineAction({ state: "TEMPLATE_FADE_IN" });

      const setFn = activeSlot === "current" ? setSlotNextData : setSlotCurrentData;
      setFn(null);
      sleepFn(1000, setFn, nextData);
      const isLastSlide = currentIndex === templates.length - 1;

      if (timelinePlayMode === "manual" && mode !== "video") {
        await waitingKeypress();
      } else {
        timeoutRef.current?.clear();
        if (isLastSlide) {
          timeoutRef.current = asyncTimeout(durationMs + 1000);
        } else {
          timeoutRef.current = asyncTimeout(adjustedDuration);
        }
        await timeoutRef.current;
      }

      if (!isMounted.current) return;
      let isFadeInOut = false;
      // how to get next template ?
      if (isVideoTransition) {
        if (!isLastSlide) {
          const currentTemplate = templates[currentIndex];
          const nextTemplate = templates[currentIndex + 1];
          const curTemplateName = currentTemplate?.template;
          const nextTemplateName = nextTemplate?.template;
          if (curTemplateName === nextTemplateName) {
            isFadeInOut = true;
          } else {
            videoDom.currentTime = 0;
            videoDom.play();
          }

        }
        await asyncTimeout(videoTransitionBefore);
      }
      fadeOut({
        slide: activeSlot,
        duration: isFadeInOut ? fadeOutDuration : isVideoTransition ? 0 : fadeOutDuration,
      });

      await asyncTimeout(isFadeInOut ? fadeOutDuration : isVideoTransition ? videoTransitionAfter : fadeOutDuration);
      if (timelinePlayMode === "manual" && mode !== "video") {
        await waitingKeypress();
      }

      if (testMode) console.timeEnd("TEMPLATE SLIDE TIME");

      setActiveSlot(activeSlot === "current" ? "next" : "current");

      if (!isMounted.current) return;

      if (isLastSlide) {
        if (mode === "video") {
          setVideoShowEnd(true);
          setShowTemplateVideo(false);
        }
        onTimelineAction({ state: "TIMELINE_END" });
      }

      onTimelineAction({ state: "END_SLIDE" });

      if (templates.length === currentIndex + 1) {
        setProcessed(0);
        setCurrentIndex(0);
      } else if (processed < templates.length) {
        setProcessed((prev) => prev + 1);
      }
    };

    asyncCall();
  }, [
    ready,
    refresh,
    currentIndex,
    _.get(currentData, "updatedAt"),
    _.get(nextData, "updatedAt"),
  ]);


  const TemplateComponent = templateComponents[_.get(slotCurrentData, "template_name")];
  const TemplateComponentNext = templateComponents[_.get(slotNextData, "template_name")];

  const timelineBackground = `${BackendConfig.apiUrl}${_.get(apiSetup, "design.timelineBackground.url")}`;

  const Images = getImagesToPreload(_.get(currentData, "data", []));

  useEffect(() => {
    if (!socket) return;
    if (!socket.connected) {
      socket.connect();
    }
  }, [socket]);

  const processMessage = async (data) => {
    await onShowAlarm(data);
  };

  const handleAlarmEvent = useCallback(
    (data) => {
      const { target } = data;
      if (target?.type === "timeline") {
        const uuids = target?.uuid;
        if (uuids.includes(timelineData.uuid)) {
          setMessageQueue((prevQueue) => [...prevQueue, data]);
        }
      }
    },
    [currentIndex],
  );

  useEffect(() => {
    if (!isProcessing && messageQueue.length > 0) {
      setIsProcessing(true);
      processQueue();
    }
  }, [messageQueue, isProcessing]);

  const onShowAlarm = async (data) => {
    setAlarmData(data);
    setShowAlarm("start");
    alarmTimeoutRef.current = asyncTimeout(30_000);
    await alarmTimeoutRef.current;
    setShowAlarm("end");
    alarmTimeoutRef.current = asyncTimeout(2000);
    await alarmTimeoutRef.current;
    setShowAlarm("");
    setAlarmData(null);
  };

  useEffect(() => {
    if (socket != null) {
      socket.on("notify_alarm", handleAlarmEvent);
    }
    return () => {
      if (socket) {
        socket.off("notify_alarm", handleAlarmEvent);
      }
    };
  }, [handleAlarmEvent, socket]);

  useEffect(() => {
    const asyncCall = async () => {
      if (Images.length) {
        const promises = preloadImages(Images);
        await Promise.all([promises]);
        setImagesLoaded(true);
      } else {
        setImagesLoaded(true);
      }
    };
    asyncCall();
  }, [Images]);

  useEffect(() => {
    if (processed > 0 && processed <= templates.length) {
      incrementInLoop();
    }
  }, [refresh, processed]);

  useEffect(() => {
    const asyncCall = async () => {
      if (mode === "video" && imagesLoaded) {
        await asyncTimeout(FrontendConfig.videoBeginColorDuration);
        setShowTemplateVideo(true);
        setReady(true);
        setVideoShowStart(false);
      }
    };
    asyncCall();
  }, [imagesLoaded]);

  // --- Ads Trigger Handlers ---
  // x-interval branch: set an interval at the timeline level (does not reset on template change).
  useEffect(() => {
    if (!adsEnabled || !xIntervalProvided) return;
    const intervalId = setInterval(() => {
      const elapsed = Date.now() - lastAdBreakEndTimeRef.current;
      if (!adBreakActiveRef.current && elapsed >= xAdsInterval * 1000) {
        handleAdBreak();
      }
    }, 1000); // check every second
    return () => clearInterval(intervalId);
  }, [adsEnabled, xIntervalProvided, xAdsInterval]);

  // x-slides branch: if x-interval is not provided, trigger ad break based on slide count.
  useEffect(() => {
    if (!adsEnabled || xIntervalProvided) return;
    console.log('x-slides branch ?')
    setTotalSlidesViewed((prev) => {
      const newTotal = prev + 1;
      if (newTotal % xSlides === 0) {
        console.log('handle ad break')
        handleAdBreak(true);
      }
      return newTotal;
    });
  }, [currentIndex, adsEnabled, xSlides, xIntervalProvided]);

  // Ad Break Sequence Handler:
  // 1. Play 3-second Ad Bumper In.
  // 2. Trigger ad break via axios (POST to /ads/timeline).
  // 3. Show countdown for the remaining ad break duration.
  // 4. Play 3-second Ad Bumper Out.
  const handleAdBreak = async (xSlidesOldStyle) => {
    if (!xSlidesOldStyle) {
      if (adBreakActive) return; // avoid duplicate triggers
      setAdBreakActive(true);
      // Step 1: Play Ad Bumper In (choose language version)
      setAdPhase("intro");
      await wait(3000);
    }

    // Step 2: Trigger ad break on backend via POST request.
    try {
      console.log("### /ads/timeline Trigger marker ###");
      await axios({
        url: `/ads/timeline`,
        method: "post",
        timeout: 30 * 1000,
        data: {
          lng: queryLng,
          timelineUuid: timelineData?.uuid,
          duration: xDuration,
          testMode: false,
          currentIndex: currentIndexRef.current,
          xIntervalProvided: xIntervalProvided,
          xAdsInterval: xAdsInterval,
        },
      });
    } catch (err) {
      console.error("Ad break axios error", err);
    }

    if (!xSlidesOldStyle) {
      // Step 3: Show countdown for the ad break (using full duration for testing)
      setAdPhase("countdown");
      const adContentDuration = xDuration * 1000;
      await wait(adContentDuration);

      // Step 4: Play Ad Bumper Out
      setAdPhase("outro");
      await wait(3000);
      // Clear ad break overlay and update cooldown timestamp AFTER outro.
      setAdPhase(null);
      setAdBreakActive(false);
      lastAdBreakEndTimeRef.current = Date.now(); // Now the 10 min countdown starts here.
    }
  };

  const client = frontend.client;


  if (mode === "video") {
    return (
      <React.Fragment>
        <VideoModeWrapper showStart={videoShowStart} showEnd={videoShowEnd} />
        <div className={"timeline-container video-mode"}>
          <img
            className={"timeline-main-bg"}
            src={
              BackendConfig.clientBodyClass === "app-opta"
                ? null
                : timelineBackground || timelineMainBg
            }
          />
          <video
            className={"timeline-transition-video"}
            controls={false}
            autoPlay={false}
            muted={true}
            loop={false}
            preload={"auto"}
            poster={
              "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
            }
          >
            <source src={client === 'onefootball_live' ? oneFootballTransition : worldcupTransition} />
          </video>
          {showTemplateVideo && (
            <>
              <div className={"template-container active-slide"}>
                {TemplateComponent && (
                  <TemplateComponent
                    {...props}
                    format={previewFormat}
                    images={Images}
                    apiSetup={apiSetup}
                    mode={currentMode}
                    data={slotCurrentData}
                    isTimeline={true}
                  />
                )}
              </div>
              <div className={"template-container next-slide"}>
                {TemplateComponentNext && (
                  <TemplateComponentNext
                    {...props}
                    format={previewFormat}
                    images={Images}
                    apiSetup={apiSetup}
                    mode={nextMode}
                    data={slotNextData}
                    isTimeline={true}
                  />
                )}
              </div>
            </>
          )}
        </div>
      </React.Fragment>
    );
  } else {
    return (
      <AlarmTemplate showAlarm={showAlarm} data={alarmData} format={previewFormat} mode={"animation"}>
        <div className={"timeline-container"}>
          <img
            className={"timeline-main-bg"}
            src={
              BackendConfig.clientBodyClass === "app-opta"
                ? null
                : timelineBackground || timelineMainBg
            }
          />
          <video
            className={"timeline-transition-video"}
            controls={false}
            autoPlay={false}
            muted={true}
            loop={false}
            preload={"auto"}
            poster={
              "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
            }
          >
            <source src={client === 'onefootball_live' ? oneFootballTransition : worldcupTransition} />
          </video>
          {!imagesLoaded ? null : (
            <>
              <div className={"template-container active-slide"}>
                {TemplateComponent && (
                  <TemplateComponent
                    {...props}
                    format={previewFormat}
                    images={Images}
                    apiSetup={apiSetup}
                    mode={currentMode}
                    animation={currentMode === "static" ? false : true}
                    data={slotCurrentData}
                    isTimeline={true}
                  />
                )}
              </div>
              <div className={"template-container next-slide"}>
                {TemplateComponentNext && (
                  <TemplateComponentNext
                    {...props}
                    format={previewFormat}
                    images={Images}
                    apiSetup={apiSetup}
                    mode={nextMode}
                    animation={nextMode === "static" ? false : true}
                    data={slotNextData}
                    isTimeline={true}
                  />
                )}
              </div>
            </>
          )}
        </div>
        {adBreakActive && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 1000,
              backgroundColor: "black",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {adPhase && (
              <video
                src={
                  adPhase === "intro"
                    ? queryLng === "de"
                      ? adBumperIntroDe
                      : adBumperIntroEn
                    : adPhase === "countdown"
                      ? queryLng === "de"
                        ? adBumperCountdownDe
                        : adBumperCountdownEn
                      : adPhase === "outro"
                        ? adBumperOutro
                        : null
                }
                autoPlay
                muted
                style={{ width: "100%", height: "100%" }}
              />
            )}
          </div>
        )}
      </AlarmTemplate>
    );
  }
};

export default Index;
